import { motion, useAnimation } from "framer-motion"
import { useInView } from "react-intersection-observer"

import { apiBaseURI, staticBaseURI } from "../../config"

const ChairItem = ({ title, image, slug }) => {
    const { inView, ref } = useInView()
    const controls = useAnimation()

    if (inView) {
        controls.start({
            opacity: 1,
            y: 0,
        })
    }

    return (
        <div ref={ref}>
            <motion.div
                initial={{ opacity: 0, y: 100 }}
                animate={controls}
                transition={{
                    duration: 0.3,
                    delay: 0.3,
                }}
                className="alumni-news-item m-2"
            >
                <div className="rounded-2xl overflow-hidden shadow-md">
                    <a href={`${staticBaseURI}/chair-details/${slug}`}>
                        <img
                            className="w-full"
                            src={`${apiBaseURI}${image}`}
                            alt={title}
                        />
                        <div className=" border-gray-300 border bg-white">
                            <div className="px-6 py-4">
                                <div className="font-bold xs:text-2xl sm:text-2xl mb-2 h-20 md:h-16">
                                    {title}
                                </div>
                            </div>
                            <div className="px-6 pt-4 pb-8">
                                <button className="font-bold xs:text-base sm:text-lg">
                                    Read More &gt;
                                </button>
                            </div>
                        </div>
                    </a>
                </div>
            </motion.div>
        </div>
    )
}

export default ChairItem
